import { useEffect, useCallback } from "react";

import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useGerarAutoInfracaoSigat = ({ dadosOs }) => {
  const {
    request: requestDownload,
    data: dataDownload,
    errors: errorDownload,
    isLoading: isLoadingDocumento,
  } = useApiClient();

  const handleImprimirDocumento = useCallback(
    (row) => {
      const dados = {
        sequencialAcaoFiscal: row.acaoFiscal ?? row.sqAcaoFiscal,
        sequencialOrdemServico: row.sequencial ?? dadosOs.sequencial,
        sequencialProdutoAcaoFiscal: null,
        sequencialComunicado: null,
        listaOcorrencias: row.ocorrencias ?? dadosOs.ocorrencias,
      };

      requestDownload(apiRoutes.fiscalizacao.ordemservico.gerarDocAutoInfracaoSigat, dados);
    },
    [requestDownload, dadosOs],
  );

  // download
  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return { handleImprimirDocumento, isLoadingDocumento };
};

export default useGerarAutoInfracaoSigat;
